export default {
  created_at:"Created",
  expire:"Expire",
  hostmaster:"Hostmaster",
  id:"ID",
  name:"Name",
  ns_first:"First Nameserver",
  ns_second:"Second Nameserver",
  refresh:"Refresh",
  retry:"Retry",
  ttl:"TTL",
  updated_at:"Update",
  user:"User",
  username:"Username",
  serial:"Serial"
}



// WEBPACK FOOTER //
// ./src/lang/de/dns.js